/*
 * ${locale}.resources.${resourceName}.name for resource names (used for the menje and page titles)
 * ${ locale }.resources.${ resourceName }.fields.${ fieldName } for field names(used for datagrid header and form input labels)
 */

export default {
    'unauthorised-action': 'je heeft niet de juiste rechten voor deze actie.',
    actions: {
        add: 'Toevoegen',
        cancel: 'Annuleren',
        close: 'Sluiten',
        create: 'Aanmaken',
        configure: 'Configureren',
        confirm: 'Bevestigen',
        deduct: 'Aftrekken',
        delete: 'Verwijderen',
        duplicate: 'Dupliceren',
        edit: 'Aanpassen',
        export: 'Exporteren',
        generated: 'Gegenereerd',
        goBack: 'Ga terug',
        hide: 'Verberg',
        import: 'Importeren',
        invite: 'Uitnodigen',
        list: 'Lijst',
        no: 'Nee',
        ok: 'Ok',
        pause: 'Pauzeren',
        refresh: 'Verversen',
        refund: 'Terugbetaling',
        reset: 'Resetten',
        resume: 'Hervatten',
        retry: 'Probeer opnieuw',
        returnTo: 'Ga terug naar',
        returnToThe: 'Ga terug naar de',
        save: 'Opslaan',
        search: 'Zoeken',
        show: 'Toon',
        signIn: 'Inloggen',
        submit: 'Opslaan',
        submit_add_another: 'Opslaan en voeg volgende toe',
        terminate: 'Beëindig',
        translate: 'Vertalen',
        yes: 'Ja',
    },
    auth: {
        forgotPassword: {
            actions: {
                iRemember: 'Ik herinner',
                resetPassword: 'Wachtwoord herstellen',
            },
            fields: {
                email: 'E-mail',
            },
            notifications: {
                success: 'Als we je account kunnen vinden, ontvangt je kort een e-mail.',
            },
            title: 'Wachtwoord vergeten?',
        },
        login: {
            fields: {
                email: 'E-mail',
                password: 'Wachtwoord',
            },
            notifications: {
                failure: 'Ongeldige inloggegevens',
            },
            noCookies: {
                description: 'Cookies zijn niet ingeschakeld in de browser. Schakel cookies in de browservoorkeuren in om door te gaan.',
                title: 'cookies vereist',
            },
        },
        logout: {
            description: 'Weet je zeker dat je zich wilt afmelden?',
            title: 'Uitloggen',
            notifications: {
                failure: 'Je account kon niet worden uitgelogd.',
                success: 'Uw account is succesvol uitgelogd',
            },
        },
    },
    components: {
        autocomplete: {
            hinttext: 'Typ om te zoeken',
        },
    },
    countries: {
        AD: 'Andorra',
        AE: 'Verenigde Arabische Emiraten',
        AF: 'Afghanistan',
        AG: 'Antigua en Barbuda',
        AI: 'Anguilla',
        AL: 'Albanië',
        AM: 'Armenië',
        AO: 'Angola',
        AQ: 'Antarctica',
        AR: 'Argentinië',
        AS: 'Amerikaans Samoa',
        AT: 'Oostenrijk',
        AU: 'Australië',
        AW: 'Aruba',
        AX: 'Aland-eilanden',
        AZ: 'Azerbeidzjan',
        BA: 'Bosnië-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'België',
        BF: 'Burkina Faso',
        BG: 'Bulgarije',
        BH: 'Bahrein',
        BI: 'Boeroendi',
        BJ: 'Benin',
        BL: 'Saint Barthelemy',
        BM: 'Bermuda',
        BN: 'Brunei',
        BO: 'Bolivia',
        BQ: 'Bonaire, Sint Eustatius en Saba',
        BR: 'Brazilië',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet-eiland',
        BW: 'Botswana',
        BY: 'Wit-Rusland',
        BZ: 'Belize',
        CA: 'Canada',
        CC: 'Cocos Eilanden',
        CD: 'Democratische Republiek Congo',
        CF: 'Centraal Afrikaanse Republiek',
        CG: 'Republiek Congo',
        CH: 'Zwitserland',
        CI: 'Ivoorkust',
        CK: 'Cookeilanden',
        CL: 'Chili',
        CM: 'Kameroen',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Kaapverdië',
        CW: 'Curacao',
        CX: 'Kersteiland',
        CY: 'Cyprus',
        CZ: 'Tsjechische Republiek',
        DE: 'Duitsland',
        DJ: 'Djibouti',
        DK: 'Denemarken',
        DM: 'Dominica',
        DO: 'Dominicaanse Republiek',
        DZ: 'Algerije',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Egypte',
        EH: 'Westelijke Sahara',
        ER: 'Eritrea',
        ES: 'Spanje',
        ET: 'Ethiopië',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Eilanden',
        FM: 'Micronesië',
        FO: 'Faeröer',
        FR: 'Frankrijk',
        GA: 'Gabon',
        GB: 'Verenigd Koningkrijk',
        GD: 'Grenada',
        GE: 'Georgië',
        GF: 'Frans Guyana',
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Groenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: 'Equatoriaal-Guinea',
        GR: 'Griekenland',
        GS: 'Zuid-Georgië en de Zuidelijke Sandwicheilanden',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinee-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard- en McDonaldeilanden',
        HN: 'Honduras',
        HR: 'Kroatië',
        HT: 'Haïti',
        HU: 'Hongarije',
        ID: 'Indonesië',
        IE: 'Ierland',
        IL: 'Israël',
        IM: 'Isle of Man',
        IN: 'Indië',
        IO: 'Brits-Indisch oceaan gebied',
        IQ: 'Irak',
        IR: 'Ik rende',
        IS: 'IJsland',
        IT: 'Italië',
        JE: 'Jersey',
        JM: 'Jamaica',
        JO: 'Jordanië',
        JP: 'Japan',
        KE: 'Kenia',
        KG: 'Kirgizië',
        KH: 'Cambodja',
        KI: 'Kiribati',
        KM: 'Comoren',
        KN: 'Saint Kitts en Nevis',
        KP: 'Noord Korea',
        KR: 'Zuid-Korea',
        KW: 'Koeweit',
        KY: 'Kaaiman Eilanden',
        KZ: 'Kazachstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litouwen',
        LU: 'Luxemburg',
        LV: 'Letland',
        LY: 'Libië',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldavië',
        ME: 'Montenegro',
        MF: 'Sint Maarten',
        MG: 'Madagascar',
        MH: 'Marshall eilanden',
        MK: 'Macedonië',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolië',
        MO: 'Macao',
        MP: 'noordelijke Mariana eilanden',
        MQ: 'Martinique',
        MR: 'Mauritanië',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldiven',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Maleisië',
        MZ: 'Mozambique',
        NA: 'Namibië',
        NC: 'Nieuw-Caledonië',
        NE: 'Niger',
        NF: 'Norfolkeiland',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Nederland',
        NO: 'Noorwegen',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nieuw-Zeeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Frans-Polynesië',
        PG: 'Papoea-Nieuw-Guinea',
        PH: 'Filippijnen',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre en Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Palestijns gebied',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Bijeenkomst',
        RO: 'Roemenië',
        RS: 'Servië',
        RU: 'Rusland',
        RW: 'Rwanda',
        SA: 'Saoedi-Arabië',
        SB: 'Solomon eilanden',
        SC: 'Seychellen',
        SD: 'Soedan',
        SE: 'Zweden',
        SG: 'Singapore',
        SH: 'Sint Helena',
        SI: 'Slovenië',
        SJ: 'Svalbard en Jan Mayen',
        SK: 'Slowakije',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalië',
        SR: 'Suriname',
        SS: 'Zuid Soedan',
        ST: 'Sao Tomé en Principe',
        SV: 'El Salvador',
        SX: 'St. Maarten',
        SY: 'Syrië',
        SZ: 'Swaziland',
        TC: 'Turks- en Caicoseilanden',
        TD: 'Tsjaad',
        TF: 'Franse zuidelijke gebieden',
        TG: 'Gaan',
        TH: 'Thailand',
        TJ: 'Tadzjikistan',
        TK: 'Tokelau',
        TL: 'Oost Timor',
        TM: 'Turkmenistan',
        TN: 'Tunesië',
        TO: 'Tonga',
        TR: 'kalkoen',
        TT: 'Trinidad en Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Oekraïne',
        UG: 'Oeganda',
        UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
        US: 'Verenigde Staten',
        UY: 'Uruguay',
        UZ: 'Oezbekistan',
        VA: 'Vaticaan',
        VC: 'Saint Vincent en de Grenadines',
        VE: 'Venezuela',
        VG: 'Britse Maagdeneilanden',
        VI: 'Amerikaanse Maagdeneilanden',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis en Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Zuid-Afrika',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    elements: {
        confirm: {
            description: 'Na deze actie kunt je de producten van het abonnement niet meer bewerken.',
            title: 'Weet je zeker dat je dit abonnement wilt bevestigen?',
        },
        delete: {
            description: 'Dit item zal permanent verwijderd worden. Deze actie kan niet ongedaan worden gemaakt.',
            title: 'Weet je zeker dat je dit wil verwijderen?',
        },
        outdatedBrowser: {
            description: 'Onze Dashboard tool ondersteund de huidige versie van je browser niet. Voor een betere ervaring met deze website, dient je browser bijgewerkt te worden naar de nieuwste versie.',
            linkText: 'Klik hier voor meer uitleg',
            title: 'Verbeter jouw Dashboard ervaring!',
        },
        terminate: {
            description: 'Het abonnement zal definitief worden beëindigd.',
            title: 'Weet je zeker dat je dit abonnement wilt beëindigen?',
        },
    },
    export: {
        error: {
            maximum_reached: 'Maar onze exports kunnen niet meer dan 15.000 boekingen bevatten. Je kan meer filters toevoegen om het aantal boekingen te verlagen, of doorgaan en de eerste 15.000 boekingen exporteren.',
            title: 'We weten dat je succesvol bent...',
        },
        description: 'Selecteer welke velden je wilt zien in je export',
        notifications: {
            empty_filters: {
                description: 'Hiervoor zijn een of meerdere filters nodig. Pas een of meer filters toe om de geselecteeerde data te exporteren.',
                title: 'We missen filters',
            },
        },
        title: 'Export voorbereiden',
        field_groups: {
            booking: 'Boeking details',
            consumer: 'Consument',
            customer: 'Klant details',
            default: 'Standaard',
            financial: 'Financiële gegevens',
            payment_method: 'Betaalmethode',
            product: 'Produkt',
            user_attributes: 'Gebruikersgegevens',
        },
        fields: {
            administration_fee: 'Administratiekosten',
            amount: 'Bedrag',
            arrival_date: 'Aankomstdatum',
            booking_date: 'Boekingsdatum',
            costfree_cancellation: 'Annuleringsverzekering',
            currency: 'Valuta',
            customer_email: 'Klanten email',
            customer_first_name: 'Voornaam klant',
            customer_last_name: 'Achternaam klant',
            customer_license_plate: 'Kenteken van de klant',
            customer_phone: 'Klant telefoon',
            customer_remarks: 'Opmerkingen van de klant',
            departure_date: 'Vertrekdatum',
            discount_amount: 'Kortingsbedrag',
            discount_company_name: 'Korting bedrijfsnaam',
            discount_owner_id: 'Korting eigenaar-ID',
            discount_title: 'Kortingstitel',
            email: 'E-mailadres',
            first_name: 'Voornaam',
            gateway: 'Gateway',
            has_failed_invoice: 'Bevat mislukte factuur',
            id: 'ID',
            internal_order_id: 'Boeking ID',
            invoiced_at: 'Gefactureerd op',
            last_name: 'Achternaam',
            locale: 'Taal',
            method: 'Methode',
            number_of_persons: 'Aantal personen',
            options_price: 'Opties prijs',
            order_id: 'Order ID',
            payment_amount_paid: 'Betaald bedrag',
            payment_method: 'Payment method',
            payment_method_status: 'Payment method status',
            price_membership_deduction: 'Membership deduction',
            payment_status: 'Betalingsstatus',
            phone: 'Telefoonnummer',
            price: 'Prijs',
            product_address: 'Product adres',
            product_id: 'Product ID',
            product: 'Product',
            provider_id: 'Provider ID',
            provider_price_total: 'Provider prijs totaal',
            provider_price: 'Provider prijs',
            provider: 'Leverancier',
            reseller_funnel: 'Reseller trechter',
            reseller_id: 'Reseller-ID',
            reseller_price_total: 'Totaal resellerprijs',
            reseller_price: 'Reseller prijs',
            reseller: 'Tussenpersoon',
            reservation_status: 'Reserveringsstatus',
            return_flight_number: 'Vluchtnummer terug',
            status: 'Status',
            transaction_fee: 'Transactiekosten',
            yield_price: 'Opbrengst prijs',
        },
    },
    fields: {
        currency: 'Valuta',
        dates: 'Datum',
        datetime: {
            never: 'Nooit',
        },
        empty: 'Onbekend',
        ends_at: 'Eindigt op',
        full: 'Volledig',
        is_scheduled: 'Gepland',
        none: 'Geen',
        optional: '(Optioneel)',
        other: 'Anders',
        percentage: 'Percentage',
        price: 'Prijs',
        price_original: 'Voormalige prijs',
        reason: 'Reden',
        size: 'Taille',
        starts_at: 'Begint op',
        updated: 'Bijgewerkt',
        weekday: {
            1: 'Maandag',
            2: 'Dinsdag',
            3: 'Woensdag',
            4: 'Donderdag',
            5: 'Vrijdag',
            6: 'Zaterdag',
            7: 'Zondag',
        },
    },
    forms: {
        email: 'Moet een e-mail zijn',
        error: {
            'location-could-not-be-resolved': 'De locatie is niet gevonden',
            'location-not-found': 'De locatie is niet gevonden',
            'the-id-format-is-invalid': 'De ID format is niet correct',
        },
        invalid: {
            discount_rule: 'Ongeldige kortingsregel',
            email: 'Ongeldige e-mail',
            first_name: 'Ongeldige voornaam',
            general: 'Ongeldige teken(s)',
            last_name: 'Ongeldige achternaam',
            match: 'De waarde met is niet gelijk aan %{field}',
            max_characters: 'Maximaal %{max} karakters of minder',
            phone: 'Moet een geldig telefoonnummer zijn',
            url: 'Deze URL is niet correct',
        },
        localisation: {
            available: {
                title: 'Voeg een taal toe',
            },
            origin: {
                description: 'Wilt je de tekst in het %{locale} vertalen naar %{target}?',
                title: 'Vertaal naar %{source}',
            },
            update: {
                description: 'Wil je de huidig ingevulde tekst van %{locale} naar het %{target} vertalen?',
                description_2: 'De vertaling zal de huidige tekst in het %{target} overschrijven.',
                description_3: 'Sla het formulier op om de wijzigingen definitief door te voeren.',
                inactive: 'Voeg eerst de tekst in het %{locale} toe. Daarna is het mogelijk om het te kunnen vertalen.',
                title: 'Vertalen van het Engels',
            },
            required: {
                description: 'Het is verplicht om alle teksten in het %{locale} in te vullen voordat de andere talen beschikbaar zijn.',
                title: 'Voeg een taal toe',
            },
        },
        no_results: 'Er zijn geen beschrijvingen toegevoegd aan dit product.',
        number: 'Must be a number',
        one_of_them_required: 'Gelieve een van deze velden in te vullen.',
        required: 'Verplicht',
        submit: {
            required: '%{locale} - %{key} is verplicht',
        },
    },
    filters: {
        add: 'Voeg een filter toe',
        category: {
            advanced: 'Geavanceerd',
            basic: 'Basis',
        },
        clear_all_filters: 'Verwijder alle filters',
        components: {
            accountId: {
                label: 'Account',
            },
            booking: {
                label: 'Boeking',
            },
            bookingOrderId: {
                label: 'Boekingsnummer',
            },
            bookingReservationOrderId: {
                label: 'Reservering order id',
            },
            cancelled: {
                label: 'Geannuleerd',
            },
            cancelledAt: {
                label: 'Geannuleerd om',
                placeholder: 'Kies een datum',
            },
            categoryId: {
                label: 'Categorie',
                placeholder: 'Kies een categorie',
            },
            companyName: {
                label: 'Bedrijfsnaam',
            },
            createdAt: {
                label: 'Gemaakt bij',
                placeholder: 'Kies een datum',
            },
            currencies: {
                label: 'Valuta\'s',
                placeholder: 'Kies een valuta',
            },
            destinationArrivalDate: {
                label: 'Aankomstdatum',
                placeholder: 'Aankomstdatum',
            },
            destinationDepartureDate: {
                label: 'Vertrekdatum',
                placeholder: 'Vertrekdatum',
            },
            email: {
                label: 'E-mail',
            },
            enabled: {
                choices: {
                    active: 'Alleen actief',
                    inactive: 'Alleen inactief',
                },
                label: 'Actief',
            },
            end_date_null_or_from: {
                label: 'Eindigt vanaf',
            },
            funnelId: {
                label: 'Campagnes',
            },
            interval: {
                choices: {
                    day: 'dag',
                    month: 'maand',
                    week: 'week',
                    year: 'jaar',
                },
                label: 'Periode',
            },
            invoice: {
                label: 'Factuur',
            },
            is_rebooked: {
                choices: {
                    active: 'Alleen herboekt',
                    inactive: 'Alleen niet herboekt',
                },
                label: 'Herboekt',
            },
            is_terminated: {
                label: 'Opgezegd',
            },
            lastName: {
                label: 'Achternaam',
            },
            licensePlate: {
                label: 'Kenteken',
            },
            name: {
                label: 'Naam',
            },
            orderId: {
                label: 'Bestel ID',
            },
            paymentStatus: {
                choices: {
                    chargedback: 'Teruggevorderd',
                    deferred: 'Uitgesteld',
                    failed: 'Mislukt',
                    inProgress: 'In behandeling',
                    refunded: 'Terugbetaald',
                    success: 'Succesvol',
                    unknown: 'Onbekend',
                },
                label: 'Betaalstatus',
                placeholder: 'Selecteer je betaling',
            },
            phone: {
                label: 'Telefoonnummer',
            },
            pointOfInterestId: {
                label: 'Point of Interest',
            },
            productId: {
                label: 'Produkt',
            },
            providerId: {
                label: 'Provider',
            },
            resellerId: {
                label: 'Reseller',
            },
            reservationStatus: {
                choices: {
                    awaiting: 'In afwachting',
                    canceled: 'Geannuleerd',
                    completed: 'Succesvol',
                    error: 'Foutief',
                    pending: 'In behandeling',
                    split: 'Opgesplitst',
                    underReview: 'Controle benodigd',
                },
                label: 'Reserveringsstatus',
            },
            subcategoryId: {
                label: 'Subcategory',
                placeholder: 'Subcategory',
            },
            status: {
                label: 'Status',
            },
            testBooking: {
                choices: {
                    real: 'Alleen echte',
                    test: 'Alleen test',
                },
                label: 'Boeking types',
            },
            userId: {
                label: 'Gebruiker',
            },
            product_membership_id: {
                label: 'Productlidmaatschap',
            },
            user_product_membership_pool_id: {
                label: 'Productlidmaatschap pool',
            },
            usesDiscountCodes: {
                choices: {
                    active: 'Gebruik kortingscodes',
                    inactive: 'Geen kortingscodes',
                },
                label: 'Maakt gebruik van kortingscodes',
            },
        },
        title: 'Filters',
        matchtype: 'Type',
        matchtypes: {
            between: 'Tussen',
            contains: 'Bevat',
            ends_with: 'Eindigt op',
            equals: 'Gelijk',
            match_all_of: 'Match alles',
            match_one_of: 'Match een van',
            near: 'In de buurt',
            range: 'Binnen',
            starts_with: 'Start met',
        },
    },
    general: {
        data_updated: 'Data updated',
        error: 'Something went wrong, please try again later...',
        images: 'Afbeeldingen',
        loading: 'Loading...',
        noMatches: 'Geen overeenkomsten gevonden',
    },
    impersonation: {
        actions: {
            log_in: 'Impersoneren',
            log_out: 'Terug naar je account',
        },
        logged_in: 'Je bent momenteel ingelogd als %{name}',
    },
    languages: {
        dutch: 'Nederlands',
        english: 'Engels',
        german: 'Duits',
        french: 'Frans',
        italian: 'Italiaans',
        spanish: 'Spaans',
    },
    localisations: {
        dialog: {
            label: 'Selecteer een taal',
        },
    },
    dropzone: {
        label: {
            button: 'Logo uploaden',
            button_image: 'Afbeelding uploaden',
            description_file_max: 'Max. bestandsgrootte: %{max} KB',
            description_max: 'Max. hoogte: %{height}px, Max. breedte: %{width}px',
            description_min: 'Min. hoogte: %{height}px, Min. breedte: %{width}px',
            format: 'formaat: %{format}',
            highlight_image: 'Markeer afbeelding',
            highlighted_image: 'Uitgelichte afbeelding',
            remove_highlight: 'Markering verwijderen',
            text: 'Klik of sleep een afbeelding',
        },
    },
    menu: {
        sidebar: {
            assets: 'Assets',
            access_points: 'Toegangspunten',
            accounts: 'Accounts',
            account_administration: 'Account beheer',
            account_details: 'Accountgegevens',
            account_yields: 'Yielding',
            administrators: 'Administrators',
            all_accounts: 'Alle accounts',
            all_users: 'Alle gebruikers',
            'api-keys': 'API keys',
            bookingStats: 'Statistieken',
            bookings: 'Boekingen',
            campaigns: 'Campagnes',
            content: 'Content',
            dashboard: 'Dashboard',
            discounts: 'Kortingen',
            internal_yield_service_user: 'Yields',
            invoices: 'Facturen',
            legaldocuments: {
                engagement_agreement: 'Opdrachtbevestiging',
                main: 'Juridische documenten',
                privacy_statement: 'Privacy verklaring',
                terms_conditions: 'Algemene voorwaarden',
            },
            memberships: 'Lidmaatschappen',
            membership_schedules: 'Lidmaatschapschema\'s',
            membership_pools: 'Lidmaatschapspools',
            order_create: 'Boeking aanmaken',
            order_create_disallowed: 'Je account is inactief. Contacteer MOBIAN om opnieuw te activeren.',
            points_of_interest: 'Points of interest',
            products: 'Producten',
            product_memberships: 'Product lidmaatschappen',
            properties: 'Eigenschappen',
            propertygroups: 'Property groups',
            reservations: 'Reserveringen',
            settings: 'Instellingen',
            subcategories: 'Subcategorieën',
            subscriptions: 'Abonnementen',
            system_administration: 'Systeembeheer',
            users: 'Gebruikers',
            webhooks: 'Webhooks',
        },
        topbar: {
            accounts: {
                current: 'Huidig',
                modal_title: 'Selecteer een account',
                no_account_selected: 'Geen gekozen account',
            },
            security: 'security',
            profile: 'Profiel',
            stop_impersonation: 'Stop impersonatie',
        },
    },
    notifications: {
        access_methods: {
            create: {
                success: 'De toegangsmethode is succesvol toegevoegd',
            },
            delete: {
                success: 'De toegangsmethode is succesvol verwijderd',
            },
            open: {
                success: 'De slagboom is geopend',
            },
            update: {
                success: 'De toegangsmethode is succesvol aangepast',
            },
        },
        account_yields: {
            create: {
                success: 'De User Yield is toegevoegd',
            },
            delete: {
                success: 'De User Yield is verwijderd',
            },
            update: {
                success: 'De User Yield is aangepast',
            },
        },
        accounts: {
            create: {
                success: 'De account is toegevoegd',
                search_user_limit: 'Alleen de eerste %{count} resultaten worden getoond, gelieve je zoekcriteria verder te verfijnen.',
            },
            update: {
                success: 'De account is aangepast',
            },
        },
        'api-keys': {
            create: {
                success: 'De API key is toegevoegd',
            },
            update: {
                success: 'De API key is aangepast',
            },
            remove: {
                success: 'De API key is verwijderd',
            },
        },
        bookings: {
            amend: {
                failure: 'De boeking is niet gewijzigd',
                success: 'De boeking is met succes gewijzigd ',
            },
            refund: {
                failure: 'De terugbetaling was niet succesvol',
                success: 'De terugbetaling was succesvol',
            },
        },
        booking: {
            cancelled: 'De boeking werd met succes geannuleerd',
        },
        export: {
            failure: 'De export kon niet worden verstuurd',
            orders: {
                failure: 'De order export kon niet worden verstuurd',
                success: 'De export wordt verzonden wanneer deze gereed is',
            },
            success: 'De export wordt verzonden wanneer deze gereed is',
        },
        campaigns: {
            create: {
                success: 'De campagne is toegevoegd',
            },
            update: {
                success: 'De campagne is aangepast',
            },
            remove: {
                success: 'De campagne is verwijderd',
            },
        },
        current_account: {
            delete: {
                success: 'De gebruiker is van dit account verwijderd',
            },
        },
        discounts: {
            create: {
                success: 'De korting is succesvol toegevoegd',
            },
            delete: {
                success: 'De korting is verwijderd',
            },
            update: {
                success: 'De korting is succesvol gewijzigd',
            },
        },
        discount_codes: {
            create: {
                success: 'De kortingscode is met succes toegevoegd',
            },
            delete: {
                success: 'De kortingscode is verwijderd',
            },
            update: {
                success: 'De kortingscode is gewijzigd',
            },
        },
        invitations: {
            created: 'De uitnodiging is met succes toegevoegd',
            deleted: 'De uitnodiging is met succes verwijderd',
            accepted: 'De uitnodiging is geaccepteerd',
            denied: 'De uitnodiging is geweigerd',
        },
        item: {
            created: 'Het item is toegevoegd',
            updated: 'Het product is correct aangepast',
        },
        memberships: {
            added: 'Gebruiker is succesvol toegevoegd aan het lidmaatschap',
            delete: {
                success: 'Gebruiker is van het lidmaatschap verwijderd',
            },
        },
        notifications: {
            inactive: 'Deze admin is inactief. Klik op de activeringsknop om de admin te activeren.',
        },
        orders: {
            cancelled: {
                success: 'Reservering geannuleerd',
            },
            retry: {
                success: 'De boeking is omgeboekt',
            },
            suspicious: 'Verdachte activiteit op deze reservering',
            update: {
                success: 'De boeking is aangepast',
            },
        },
        points_of_interest: {
            create: {
                success: 'De POI is toegevoegd',
            },
            delete: {
                success: 'De POI is verwijderd',
            },
            images: {
                create: {
                    success: 'De afbeelding is succesvol toegevoegd',
                },
                delete: {
                    success: 'De afbeelding is met succes verwijderd',
                },
            },
            import: {
                success: 'De POI\'s zijn successvol toegevoegd',
            },
            update: {
                success: 'De POI is aangepast',
            },
        },
        products: {
            create: {
                success: 'Het product is toegevoegd',
            },
            configuration: {
                administration_fee: {
                    maximum: 'Maximaal',
                    maximum_placeholder: 'bijv. 1.99, 2.50',
                    minimum: 'Minimaal',
                    minimum_placeholder: 'bijv. 1.99, 2.50',
                    percentage: 'Percentage',
                    percentage_placeholder: 'bijv. 0.10 (10%), 0.03 (3%)',
                },
                allow_exceed_capacity_from: 'Ongeldige toegestane overschrijding van de capaciteit',
                allow_overstay: 'Ongeldige toegestane overstay',
                arrival_dates_blocked: 'Ongeldige geblokkeerde aankomstdatums',
                blocked_dates: 'Ongeldige geblokkeerde datums',
                capacity: 'Ongeldige capaciteit',
                departure_dates_blocked: 'Ongeldige geblokkeerde aankomstdatums',
                freeze_period: 'Ongeldige bevriezingsperiode',
                leeway_arrival: 'Ongeldige aankomsttijd speling',
                leeway_departure: 'Ongeldige vertrektijd speling',
                maximum_advance: 'Ongeldige maximale vooruitlooptijd',
                maximum_duration: 'Ongeldige minimale vooruitlooptijd',
                minimum_advance: 'Ongeldige minimale vooruitlooptijd',
                minimum_duration: 'Ongeldige duur',
                number_of_persons: 'Ongeldig aantal personen',
                operational_times: 'Ongeldige operationele tijd(en), weekdagspecifiek of niet-specifiek alleen toegestaan',
                sales_price: 'Ongeldige verkoopprijs',
                split_percentage: 'Ongeldig Split Price percentage',
                terms_and_conditions: {
                    name: 'Ongeldige naam',
                    link: 'Ongeldige URL',
                },
                vat_percentage: 'Ongeldig BTW percentage',
                voucher_include_invoice: 'Ongeldige voucher inclusief factuur',
            },
            delete: {
                success: 'Het product is verwijderd.',
            },
            update: {
                success: 'Het product is aangepast',
            },
            failure: 'Product niet verwijderd',
            images: {
                create: {
                    success: 'De afbeelding is succesvol toegevoegd',
                },
                delete: {
                    success: 'De afbeelding is met succes verwijderd',
                },
            },
            localisation: {
                update: {
                    success: 'De teksten zijn succesvol aangepast',
                },
            },
            logo: {
                create: {
                    failure: 'Er is iets fout gegaan bij het uploaden van het logo',
                    success: 'Het logo wordt geüpload',
                },
                delete: {
                    failure: 'Er is iets fout gegaan bij het verwijderen van het logo',
                    success: 'Het logo is verwijderd',
                },
            },
            property: {
                create: {
                    success: 'Het product is toegevoegd',
                },
                update: {
                    success: 'Het product is aangepast',
                },
                remove: {
                    success: 'Het product is verwijderd',
                },
            },
            related: {
                create: {
                    success: 'Het product is gelinkt',
                },
                delete: {
                    success: 'De relatie tussen de producten is verwijderd',
                },
            },
            resource: {
                available_resources: {
                    failure: 'Er is iets fout gegaan bij het ophalen van de beschikbare bronnen',
                },
                update: {
                    success: 'De product bron is aangepast',
                },
            },
        },
        profile: {
            update: {
                success: 'Je profiel is aangepast',
            },
        },
        propertygroups: {
            create: {
                success: 'De eigenschapgroep is toegevoegd',
            },
            delete: {
                success: 'De eigenschapgroep is verwijderd',
            },
            update: {
                success: 'De eigenschapgroep is aangepast',
            },
        },
        properties: {
            create: {
                success: 'De eigenschappen zijn toegevoegd',
            },
            delete: {
                success: 'De eigenschappen zijn verwijderd',
            },
            update: {
                success: 'De eigenschappen zijn aangepast',
            },
        },
        subcategories: {
            create: {
                success: 'De subcategorie is toegevoegd',
            },
            update: {
                success: 'De subcategorie is verwijderd',
            },
            remove: {
                success: 'De subcategorie is aangepast',
            },
        },
        subscriptions: {
            create: {
                success: 'Het abonnement is succesvol toegevoegd',
            },
            delete: {
                success: 'Het abonnement is succesvol verwijderd',
            },
            update: {
                success: 'Het abonnement is succesvol gewijzigd',
            },
            confirm: {
                success: 'Het abonnement is succesvol bevestigd',
            },
            terminate: {
                success: 'Het abonnement is succesvol beëindigd',
            },
        },
        subscriptionProducts: {
            create: {
                success: 'Het abonnementsproduct is succesvol toegevoegd',
            },
            delete: {
                success: 'Het abonnementsproduct is succesvol verwijderd',
            },
        },
        users: {
            create: {
                success: 'De gebruiker is toegevoegd',
            },
            delete: {
                success: 'De gebruiker is verwijderd',
            },
            update: {
                success: 'De gebruiker is aangepast',
            },
            confirmed: {
                success: 'De gebruiker is met succes bevestigd',
            },
            password: {
                failure: 'Oeps, er ging iets fout tijdens het verzenden van het verzoek. Probeer het later nog eens.',
                success: 'De gebruiker zal door middel van een e-mail worden geïnformeerd.',
            },
        },
        user_product_membership: {
            create: {
                success: 'De gebruikersproductlidmaatschap is toegevoegd',
            },
            delete: {
                success: 'De gebruikersproductlidmaatschap is verwijderd',
            },
            update: {
                success: 'De gebruikersproductlidmaatschap is aangepast',
            },
        },
        utilities: {
            translate: {
                create: {
                    success: 'De basistekst is succesvol vertaald.',
                },
            },
        },
        webhooks: {
            create: {
                success: 'De webhook is succesvol toegevoegd',
            },
            update: {
                success: 'De webhook is succesvol aangepast',
            },
            remove: {
                success: 'De webhook is succesvol verwijderd',
            },
        },
    },
    pages: {
        booking_tool: {
            not_available: {
                text: 'Het lijkt erop dat er geen Dashboard-vergelijkingstool beschikbaar is voor dit account. Neem voor meer informatie contact op met jouw accountmanager.',
                title: 'Oh nee... :(',
            },
        },
        create_booking: {
            description: 'Voordat je de producten kunt zien, vragen we je om deze velden in te vullen om de zoekopdracht specifieker te maken.',
            form: {
                errors: {
                    destination_arrival_date: 'Vul alstublieft een datum in',
                    destination_arrival_time: 'Vul alstublieft een tijd in',
                    destination_departure_date: 'Vul alstublieft een datum in',
                    destination_departure_time: 'Vul alstublieft een tijd in',
                    destination_google_place_id: 'Vul alstublieft een bestemming in',
                    number_of_persons: 'Vul alstublieft het aantal personen in',
                    one_way: 'Vul alstublieft het reistype in',
                    origin_google_place_id: 'Vul alstublieft het adres in waar je opgehaald wilt worden',
                },
                fields: {
                    destination_arrival_date: 'Wanneer wilt je weggaan?',
                    destination_arrival_time: 'Vertrektijd',
                    destination_departure_date: 'Wanneer wilt je terugkomen?',
                    destination_departure_time: 'Retourtijd',
                    destination_google_place_id: 'Wat is de bestemming?',
                    one_way: {
                        retour_trip: 'Retour reis',
                        single_trip: 'Enkele reis',
                        title: 'Reistype',
                    },
                    origin_google_place_id: 'Mijn adres',
                    service: {
                        park_and_sleep: 'Parkeren en Overnachten',
                        park_and_walk: 'Parkeren op loopafstand',
                        public_transport: 'Openbaar Vervoer',
                        short_long_parking: 'Kort/lang parkeren',
                        taxi: 'Taxi',
                        title: 'Service opties',
                        valet_parking: 'Valet parkeren',
                    },
                },
            },
            not_available: {
                text: 'Het lijkt erop dat er geen Dashboard-vergelijkingstool beschikbaar is voor dit account. Neem voor meer informatie contact op met jouw accountmanager.',
                title: 'Oh nee... :(',
            },
            title: 'Maak een boeking',
        },
        dashboard: {
            select: 'Selecteer jouw valuta',
            widgets: {
                statistics_card: {
                    bookings: 'Boekingen',
                    current_week: 'Deze week',
                    last_week: 'Vorige week',
                    today: 'Vandaag',
                    week: 'Week',
                    yesterday: 'Gisteren',
                },
                statistics_graph: {
                    current_month: 'Afgelopen 4 weken',
                    previous_year: 'Vorig jaar',
                    title: 'Boekingen',
                },
            },
        },
    },
    resources: {
        access_methods: {
            create: {
                title: 'Maak een toegangsmethode',
            },
            delete: {
                title: 'Toegangsmethode verwijderen',
                description: 'Weet je zeker dat je deze toegangsmethode wilt verwijderen?',
            },
            edit: {
                title: 'Bewerk deze toegangsmethode',
            },
            fields: {
                access_id: 'Toegangs ID',
                access_point_access_method_id: 'Toegangspunt toegangsmethode ID',
                access_point_id: 'Toegangspunt ID',
                carpark_id: 'Parkeerplaats-ID',
                connector_id: 'Connector-ID',
                custom_counter_id: 'Teller ID op maat',
                depot_id: 'Depot-ID',
                direction: 'Richting',
                door_id: 'Deur-ID',
                enabled: 'Toestand',
                gate_id: 'Gate-ID',
                is_allowed_for_users: 'Toegang voor gebruikers',
                location_id: 'Locatie-ID',
                name: 'Naam',
                phone: 'Telefoonnummer',
                phone_country: 'Land van telefoonnummer',
                product_id: 'Product ID',
                station_id: 'Stations-ID',
                subscription_id: 'Abonnement ID',
            },
            list: {
                active: 'Actief',
                direction: 'Richting',
                directions: {
                    1: 'Inrijden / Verlaten',
                    2: 'Ingang',
                    3: 'Uitgang',
                },
                enabled: 'Toestand',
                inactive: 'Inactief',
            },
            no_results: 'Geen toegangsmethoden gevonden',
            open: 'Open slagboom',
            requesting: 'Verzoekend',
            title: 'Toegangsmethoden',
        },
        access_points: {
            actions: {
                create: {
                    title: 'Maak een toegangspunt aan',
                },
                edit: {
                    title: 'Pas deze toegangspunt aan: %{title}',
                },
            },
            fields: {
                access_point: 'Kies een toegangspunt',
                access_method: 'Kies een toegangsmethode',
                product: 'Product',
                title: 'Titel',
                type: 'Type',
            },
            no_results: 'Geen toegangspunten gevonden',
            title: 'Toegangspunten',
            types: {
                access: 'Toegang',
                on_site: 'Ter plaatse',
            },
        },
        accounts: {
            actions: {
                activate: 'Activeren',
                create: 'Maak een account aan',
                deactivate: 'Deactiveren',
                edit: 'Pas de account aan',
            },
            activity: {
                activate: {
                    title: 'De account wordt geactiveerd',
                    description: 'Wanneer de account actief is kan deze inloggen in het dashboard, de apps en onze services gebruiken.',
                },
                deactivate: {
                    title: 'De account wordt gedeactiveerd',
                    description: 'Wanneer de gebruik inactief is kan deze niet langer inloggen in het dashboard, de apps en onze services gebruiken.',
                },
            },
            fields: {
                address: 'Adres',
                bic: 'BIC',
                city: 'Stad',
                contact_details: 'Contact gegevens',
                contact_email: 'E-mail',
                contact_emergency_phone: 'Noodgevallen telefoon',
                contact_phone: 'Contacttelefoon',
                contact_whatsapp: 'Whatsapp nummer',
                country: 'Land',
                email: 'E-mail',
                iban: 'IBAN',
                is_enabled: 'Actief',
                last_name: 'Achternaam',
                locale: 'Taal',
                name: 'Naam',
                notify_on_cancelled: 'Notify on cancelled',
                notify_on_created: 'Notify on created',
                notify_on_modified: 'Notify on modified',
                orders: 'Orders',
                owner: 'Eigenaar',
                phone: 'Telefoon',
                registration: 'Registratie',
                role: 'Role',
                vat: 'BTW',
                zipcode: 'Postcode',
            },
            filters: {
                active: {
                    active: 'Alleen actief',
                    inactive: 'Alleen inactief',
                },
            },
            forms: {
                account: 'Accountgegevens',
                account_search_user: 'Gebruiker zoeken',
                account_select_user: 'Gebruiker selecteren',
                address: 'Adresgegevens',
                company: 'Bedrijfsgegevens',
                contact: 'Contactgegevens',
                general: 'Algemeen',
                notifications: 'Email notification preferences',
                products: 'Laatst bijgewerkte producten',
                registrations: 'Registraties',
            },
            name: 'Account',
            products: {
                actions: {
                    list: 'Toon alle producten (%{total})',
                },
            },
            roles: {
                administrator: 'Beheerder',
                provider: 'Provider',
                reseller: 'Reseller',
            },
            select_user: {
                table: {
                    email: 'E-mail',
                    name: 'Naam',
                },
            },
            title: 'Accounts',
        },
        account_yields: {
            actions: {
                create: 'Creëer een yield',
                edit: 'Wijzig de yield',
            },
            fields: {
                accountId: 'Gebruiker',
                yield: 'Yield',
            },
            title: 'Yields',
        },
        'api-keys': {
            actions: {
                create: 'Maak een API key aan',
                edit: 'Wijzig de API Key.',
            },
            error: {
                description: 'Het maximale aantal beschikbare API-sleutels is bereikt. je kunt geen API-sleutels meer maken. Verwijder er één, voordat je een nieuwe aanmaakt.',
                title: 'Oeps ...',
            },
            fields: {
                created_at: 'Aangemaakt',
                last_used_at: 'Laatst gebruikt',
                name: 'Naam',
                token: 'Sleutel',
            },
            modal: {
                description: 'Bij deze jouw nieuwe API key. <strong>De token is na het sluiten van dit scherm niet langer inzichtelijk. Verlies hem niet!</strong> Je kan de API key op ieder gewenst moment verwijderen.',
                title: 'API key voor %{name}',
            },
            title: 'API keys',
        },
        bookings: {
            actions: {
                edit: 'Boeking: %{name} (%{id})',
            },
            amend: {
                buttons: {
                    paymentInvoice: 'Betaal via factuur',
                    paymentMethod: 'Selecteer betaalmethode',
                    price: 'Nieuwe prijs',
                },
                loading: {
                    'price-check-error': 'Er ging iets mis bij het controleren op een nieuwe prijs',
                    'payment-invoice': 'Betaling via factuur',
                    'payment-link': 'Betaallink maken',
                    'payment-not-required': 'Formulier opslaan met de bijgewerkte waarden',
                    form: 'Nieuwe prijzen ophalen',
                    payments: 'Alle betaalmethoden ophalen',
                    transactions: 'Een transactie aanmaken',
                },
                messages: {
                    'amendError': 'Er is iets fout gegaan tijdens het opslaan van het formulier.',
                    'payment-invoice': 'De betaling is factureerbaar. Je kunt het formulier opslaan.',
                    'payment-not-required': 'Betaling is niet vereist. Je kan het formulier opslaan.',
                    'payment-required': 'Het prijsverschil is exclusief mogelijke transactiekosten.',
                    'price-check-error': 'Er ging iets mis bij het controleren op een nieuwe prijs',
                    availability: 'Dit product is niet langer beschikbaar.',
                    linkCopied: 'De betaallink wordt gekopieerd',
                },
                prices: {
                    current: 'Huidige prijs',
                    difference: 'Verschil',
                    new: 'Nieuwe prijs',
                },
                phase: {
                    paymentLink: 'Uw betaallink voor %{title} - %{method}',
                },
                title: 'Wijzig de boeking',
            },
            fields: {
                createdAt: 'Gemaakt bij',
                customerRemarks: 'Opmerkingen van de klant',
                destinationArrivalDate: 'Aankomstdatum',
                email: 'E-mail',
                firstName: 'Voornaam',
                fullName: 'Naam',
                funnelId: 'Campagne',
                lastName: 'Achternaam',
                licensePlate: 'Kenteken',
                locale: 'Taal',
                orderId: 'Booking ID',
                phone: 'Telefoon',
                price: 'Prijs',
                product: 'Produkt',
                resellerId: 'Reseller',
                status: 'Status',
            },
            forms: {
                additional: 'Extra',
                general: 'Algemeen',
            },
            refund: 'Boeking terugbetalen',
            title: 'Boekingen',
        },
        campaigns: {
            actions: {
                create: 'Maak een campagne aan',
                edit: 'Wijzig deze campagne: %{title}',
            },
            fields: {
                accountId: 'Reseller',
                id: 'ID',
                identifier: 'Identifier',
                name: 'Naam',
            },
            name: 'Campagne',
            title: 'Campagnes',
            show: {
                api: 'API',
                catalogue: 'Catalogus',
                week: 'Week',
                last_week: 'Bookings over the last weeks',
                week_number: 'Week #',
                bookings_amount: 'Aantal boekingen',
                tabs_title: 'Informatie over catalogus- / API-gebruik',
                catalogue_p1: 'Bent je niet klaar voor een volledige API-integratie, maar wilt je snel en veilig beginnen? De boekingstrechter van MOBIAN kan gemakkelijk worden gebruikt en werkt onmiddellijk na het maken van een campagne. Het enige dat je nodig heeft om in je link mee te sturen, is je campagne-ID. je ID is een uniek token waarmee we de boeking gemakkelijk aan je account kunnen toevoegen alsof je deze via je eigen website hebt verkocht. We hebben hieronder een voorbeeld toegevoegd:',
                catalogue_p2: 'je kunt de campagne-ID toevoegen aan elke pagina die de boekingstrechter te bieden heeft. Op die manier kunt je je gebruiker altijd overal in de trechter laten beginnen en de ervaring afstemmen op hun behoeften.',
                catalogue_p3: 'Zodra een gebruiker op de pagina terechtkomt waaraan je campagne is gekoppeld, ontvangt hij een markering. Deze markering zorgt ervoor dat elke verkoop die deze persoon doet terwijl hij deze heeft, onder je account valt. Let op; in het geval dat een gebruiker de boekingstrechter bezoekt met een nieuwe campagne, zal dit de huidige actieve markering overschrijven. De markers hebben een cooldown van 72 uur waarna deze wordt gedeactiveerd. Boekingen die na die periode zijn gemaakt, worden pas aan je account toegevoegd als ze opnieuw een link met je ID bezoeken.',
                api_p1: 'Mooi! je wilt integreren met de API, maar je wilt verschillende campagnes of trechters definiëren waarmee je verkoopt. je kunt eenvoudig een boeking aan de campagne koppelen. Hiervoor heeft je mogelijk je technische personeel nodig om iets aan te passen in de verzoeken die je naar onze API stuurt. Bij het maken van een boeking communiceert je al veel informatie en voegen we nog een stuk toe aan de puzzel. In de documentatie vind je een parameter met de naam funnel_id. Voor dit gedeelte informatie moet je een ID hebben die je kunt invoeren.',
                api_p2: 'De ID voor deze campagne is:',
                api_p3: 'Nadat boekingen met deze ID zijn gemaakt, worden ze automatisch aan deze campagne toegevoegd.',
            },
        },
        bookingStats: {
            fields: {
                AUD: 'AUD',
                CHF: 'CHF',
                EUR: 'EUR',
                GBP: 'GBP',
                NZD: 'NZD',
                SEK: 'SEK',
                USD: 'USD',
                amount: 'Bedrag',
                bookings: 'Boekingen',
                label: 'Datum',
                total: 'Totaal',
            },
            name: 'Statistieken',
            title: 'Boekingsstatistieken',
        },
        discount_codes: {
            actions: {
                create: 'Maak een kortingscode aan',
                edit: 'Wijzig kortingscode: %{title}',
            },
            components: {
                expiry_date: {
                    placeholder: 'Vervaldatum',
                },
                status: {
                    choices: {
                        unused: 'Ongebruikt',
                        used: 'Gebruikt',
                    },
                },
                type: {
                    choices: {
                        multi: 'Multi-gebruik',
                        single: 'Eenmalig gebruik',
                        wallet: 'Portemonnee',
                    },
                },
            },
            fields: {
                amount: 'Bedrag',
                amount_used: 'Gebruikte bedrag',
                currency: 'Valuta',
                expiry_date: 'Vervaldatum',
                id: 'ID',
                is_enabled: 'Actief',
                last_used_at: 'Laatst gebruikt op',
                percentage: 'Percentage',
                status: 'Status',
                token: 'Token',
                type: 'Type',
            },
            title: 'Kortingscodes',
        },
        discounts: {
            actions: {
                activate: 'Activeren',
                create: 'Maak een korting aan',
                deactivate: 'Deactiveren',
                edit: 'Wijzig deze korting: %{title}',
                list: 'Lijst',
            },
            activity: {
                activate: {
                    title: 'Activeren',
                    description: 'Weet je zeker dat je deze korting wilt activeren?',
                },
                deactivate: {
                    title: 'Deactiveren',
                    description: 'Weet je zeker dat je deze korting wilt deactiveren?',
                },
            },
            fields: {
                accountId: 'Rekening',
                amount: 'Bedrag',
                apply_on_fees: 'Toepassen op kosten',
                created_at: 'Gemaakt op',
                currency: 'Valuta',
                end_processing: 'Beëindig de verwerking',
                expiry_date: 'Vervaldatum',
                id: 'ID',
                is_enabled: 'Actief',
                limit: 'Limiet',
                percentage: 'Percentage',
                priority: 'Prioriteit',
                title: 'Titel',
                uses_discount_codes: 'Maakt gebruik van kortingscodes',
            },
            forms: {
                account: 'Rekening',
                discount_codes: 'Kortingscodes',
                general: 'Algemeen',
                manage_discount_codes: 'Kortingscodes',
            },
            operators: {
                labels: {
                    and: 'En',
                    equal_or_greater_than: 'Gelijk aan of groter dan',
                    equal_or_less_than: 'Gelijk aan of minder dan',
                    equal: 'Is gelijk',
                    greater_than: 'Groter dan',
                    less_than: 'Minder dan',
                    not_equal: 'Is niet gelijk aan',
                    or: 'Of',
                    within: 'Tussen',
                },
                title: 'Operator',
            },
            placeholders: {
                email_domain: 'bijv. nu.nl',
            },
            rules: {
                appliance: 'Toepassingsregels',
                condition: 'Voorwaardelijke regels',
                title: 'Toepassing- & Voorwaardelijke Regels',
                no_results: 'Er zijn geen %{type}',
            },
            types: {
                global: 'Globaal',
                regular: 'Normaal',
            },
            title: 'Kortingen',
        },
        invitations: {

            actions: {
                accept: {
                    title: 'Uitnodiging accepteren',
                    description: 'Wil je deze uitnodiging accepteren?',
                },
                deny: {
                    title: 'Uitnodiging weigeren',
                    description: 'Wil je deze uitnodiging ontkennen?',
                },
            },
            no_invitations: 'Geen uitnodigingen gevonden.',
            open_invitations: 'Open uitnodigingen',
            request_title: 'Uitnodigingsverzoeken',
            sent_title: 'Verstuurde uitnodigingen',
            title: 'Uitnodigingen',
        },
        invoices: {
            download: 'Download factuur',
            export: {
                success: 'Facturen zijn succesvol geëxporteerd.',
                title: 'Facturen exporteren',
                lines: {
                    title: 'Exporteer factuurregels',
                },
            },
            fields: {
                amount: 'Bedrag',
                invoiced_at: 'Gefactureerd op',
                status: 'Status',
            },
            show: {
                details: 'Gegevens',
                title: 'Factuur tonen',
            },
            status: {
                charged_back: 'Teruggeboekt',
                open: 'Open',
                overdue: 'Achterstallig',
                paid: 'Betaald',
                paid_manually: 'Handmatig betaald',
                processing: 'Processing',
            },
            title: 'Facturen',
        },
        general: {
            fields: {
                boolean: {
                    yes: 'Ja',
                    no: 'Nee',
                },
            },
        },
        memberships: {
            actions: {
                edit: 'Wijzig dit lidmaatschap: %{title}',
            },
            fields: {
                concurrency: 'Gelijkvaluta',
                purge_reservations: 'Zuiver reserveringen',
                paid_by_invoice: 'Betaald per factuur',
            },
            messages: {
                created: {
                    success: 'Lidmaatschap met succes gecreëerd',
                },
                deleted: {
                    success: 'Lidmaatschap is succesvol verwijderd',
                },
                updated: {
                    success: 'Lidmaatschap is succesvol bijgewerkt',
                },
            },
        },
        membership_schedules: {
            messages: {
                created: {
                    success: 'Lidmaatschapschema succesvol aangemaakt',
                },
                deleted: {
                    success: 'Lidmaatschapschema succesvol verwijderd',
                },
                updated: {
                    success: 'Lidmaatschapschema succesvol bijgewerkt',
                },
            },
        },
        no_account: {
            description: 'Om het dashboard te kunnen gebruiken, moet je verbonden zijn met een partner. Een van onze partners heeft je misschien al een uitnodiging gestuurd om deel te nemen aan hun bedrijfsaccount. Klik op de knop hierboven om te zien of je openstaande uitnodigingen hebt.',
            title: 'Geen accounts beschikbaar',
        },
        orders: {
            actions: {
                check_new_price: 'Nieuwe prijs ophalen',
                csv: 'CSV',
                export: 'Boekingen exporteren',
                export_related: 'Reserveringen exporteren',
                order_email_resent: 'Order email resent',
                resend_email: 'E-mail nogmaals versturen',
                retry: 'Opnieuw',
            },
            amend: {
                message: {
                    availability: 'Dit product is niet langer beschikbaar.',
                    payment: {
                        required: 'Het prijsverschil omvat geen potentiële transactiekosten.',
                    },
                },
                payment_method: {
                    button: 'Betaalmethode',
                },
                payment_link: {
                    title: 'De betaallink voor %{title}:',
                },
                price: {
                    current: 'Huidige prijs',
                    new: 'Nieuwe prijs',
                    difference: 'Verschil',
                },
                title: 'Wijzig de boeking',
            },
            cancel: {
                description: 'Weet je zeker dat je deze boeking wilt annuleren?',
                title: 'Annuleer Boeking',
            },
            edit: {
                no_longer_editable: 'Deze informatie kan niet meer in het systeem worden bewerkt, neem rechtstreeks contact op met de aanbieder.',
            },
            fields: {
                campaigns: 'campagnes',
                cancelled_at: 'Geannuleerd op',
                country_code: 'Landcode',
                commission: {
                    int_yield_price: 'Reseller service yield',
                    mobian_commission_total: 'Total',
                    mobian_product_commission_price: 'MOBIAN commission',
                    mobian_product_yield_commission_price: 'Product yield commission',
                    mobian_vat_amount: 'Commission VAT',
                    mobian_vat_price: 'Total',
                    price_administration_fee: 'Administration Costs',
                    price_base: 'Base price',
                    price_costfree_cancellation: 'Cost Free Cancellation',
                    price_options: 'Options',
                    provider_total_price: 'Subtotal',
                    reseller_commission_total: 'Reseller commission',
                    reseller_product_commission_price: 'Product commission',
                    reseller_product_price: 'Booking total',
                    reseller_product_yield_commission_price: 'Yield commission',
                    reseller_vat_amount: 'VAT',
                    reseller_vat_price: 'Total',
                },
                created_at: 'Aanmaakdatum',
                customer_remarks: 'Customer Remarks',
                destination_arrival_date: {
                    hours: 'uren',
                    label: 'Aankomstdatum',
                    minutes: 'minuten',
                },
                destination_address: 'Afzetlocatie',
                destination_departure_date: {
                    hours: 'uren',
                    label: 'Vertrekdatum',
                    minutes: 'minuten',
                },
                drop_off_date: 'Startdatum',
                ending_at: 'Eindigd om',
                email: 'E-mail',
                first_name: 'Voornaam',
                flight_number: 'Vluchtnummer',
                full_name: 'Naam',
                is_test: 'Test',
                last_name: 'Achternaam',
                license_plate: 'Kentekenplaat',
                locale: 'Taal',
                location_address: 'Locatie',
                number_of_persons: 'Aantal personen',
                order_id: 'Boeking ID',
                origin_address: 'Ophaallocatie',
                payment_amount_paid: 'Hoeveel betaald',
                payment_status: 'Betalingsstatus',
                phone: 'Telefoon/mobiel',
                pick_up_date: 'Ophaaldatum',
                price: 'Prijs',
                product: 'Product',
                provider: 'Provider',
                reservation_status: 'Reserveringsstatus',
                return_flight_number: 'Vluchtnummer',
                starting_at: 'Start vanaf',
                status: 'status',
                updated_at: 'Laatst bijgewerkt',
            },
            filters: {
                cancelled_at: {
                    label: 'Geannuleerd op',
                    placeholder: 'Geannuleerd op',
                },
                createdAt: {
                    label: 'Aanmaakdatum',
                    placeholder: 'Aanmaakdatum',
                },
                currencies: {
                    label: 'Valuta',
                },
                destination_address: {
                    label: 'Afzet locatie',
                },
                destination_arrival_date: {
                    label: 'Aankomstdatum',
                    placeholder: 'Aankomstdatum',
                },
                destination_departure_date: {
                    label: 'Vertrekdatum',
                    placeholder: 'Vertrekdatum',
                },
                interval: {
                    choices: {
                        day: 'dag',
                        month: 'maand',
                        week: 'week',
                        year: 'jaar',
                    },
                    label: 'Periode',
                },
                is_test_order: {
                    choices: {
                        only_real: 'Echte',
                        only_test: 'Test',
                    },
                    label: 'Boekingen',
                },
                last_name: 'Achternaam',
                payment_status: {
                    choices: {
                        chargedback: 'Teruggevorderd',
                        deferred: 'Uitgesteld',
                        failed: 'Mislukt',
                        in_progress: 'In behandeling',
                        refunded: 'Terugbetaald',
                        success: 'Succesvol',
                        unknown: 'Onbekend',
                    },
                    label: 'Betaalstatus',
                },
                origin_address: {
                    label: 'Ophaalplaats',
                },
                reservation_status: {
                    choices: {
                        canceled: 'Geannuleerd',
                        completed: 'Succesvol',
                        error: 'Foutief',
                        pending: 'In behandeling',
                        split: 'Opgesplitst',
                        under_review: 'Controle benodigd',
                    },
                    label: 'Reserveringsstatus',
                },
            },
            information: {
                consumer_communication: 'Deze klant ontvangt geen automatische boekingsmails.',
                multibookings: {
                    split_from: 'This booking belongs to multi-booking ',
                    split_to: 'This booking has been split to ',
                },
                test_booking: 'Deze boeking is gemaakt als een testorder.',
            },
            name: 'Boekingen',
            paymentSlip: {
                download: {
                    title: 'Download Betalingsbewijs',
                },
                send: {
                    description: 'De consument ontvangt een betalingsbewijs met elke update, weet je zeker dat je het betalingsbewijs handmatig wilt verzenden?',
                    success: 'Betalingsbewijs succesvol verstuurd',
                    title: 'Verstuur Betalingsbewijs',
                },
                title: 'Betalingsbewijs',
            },
            receipt: {
                administration_costs: 'Administratiekosten',
                administration_fees: 'Administratiekosten',
                base_price: 'Base price',
                costfree_cancellation: 'Cost Free Cancellation',
                membership_deduction: 'Membership korting',
                options: 'Opties',
                service_yield: 'Service yield',
                split_deduction: 'Split deduction',
                subtotal_additional: 'Subtotaal extra kosten',
                subtotal_base: 'Subtotaal',
                subtotal_discounts: 'Subtotaal kortingen',
                total: 'Totaal',
                transaction_fees: 'Transactiekosten',
            },
            retry: {
                description: 'Weet je zeker dat je deze boeking wilt herboeken?',
                title: 'Boek de boeking opnieuw',
            },
            show: {
                activities: {
                    booking: {
                        empty: 'Er zijn geen gelogde activiteiten voor deze boeking.',
                        label: 'Activiteiten',
                        table: {
                            activity: 'Activiteit',
                            actor: 'Acteur',
                            created_at: 'Datum',
                            property: 'Waarde',
                            status: 'Toestand',
                            target_id: 'Identificeren',
                            target_type: 'Doelwit',
                        },
                    },
                },
                booking_information: 'Boekinginformatie',
                paid_on_invoice: 'Deze boeking wordt op factuur betaald.',
                product: 'Product',
                reseller: 'Reseller',
                reservation: 'Reservering',
                reservation_details: 'Reservering details',
                travel_details: 'Reis details',
            },
            tabs: {
                activities: 'Activiteiten',
                commission: 'Commissie',
                customer: 'Klant',
                payment: 'Betaling',
                travel: 'Reis',
            },
            voucher: {
                download: {
                    title: 'Download Voucher',
                },
                send: {
                    description: 'De consument ontvangt een voucher voor iedere update, weet je zeker dat je de voucher nogmaals wilt versturen?',
                    success: 'Voucher succesvol verstuurd!',
                    title: 'Verstuur Voucher',
                },
                after_alteration: {
                    description: 'Wil je de klant informeren over de aanpassingen?',
                },
                title: 'Voucher',
            },
        },
        password: {
            error: {
                password_current: 'Het wachtwoord komt niet overheen met het huidige wachtwoord.',
            },
            name: 'Verander je wachtwoord',
            fields: {
                password_current: 'Huidig wachtwoord',
                password_new: 'Nieuw wachtwoord',
                password_confirmation: 'Bevestig het nieuwe wachtwoord',
            },
            success: 'Het wachtwoord is opgeslagen!',
        },
        points_of_interest: {
            actions: {
                create: 'Maak een nieuwe Point of Interest aan',
                edit: 'Bewerk de Point of Interest: %{title}',
                show: 'Point of Interest: %{title}',
            },
            fields: {
                address: 'Adres',
                city: 'Stad',
                country: 'Land',
                google_place_id: 'Google Place ID',
                id: 'ID',
                is_highlighted: 'Uitgelicht',
                latitude: 'Latitude',
                location_x: 'Locatie x',
                location_y: 'Locatie y',
                longitude: 'Longitude',
                name: 'Naam',
                state: 'Staat/Provincie',
                street: 'Straat',
                street_number: 'Nº',
                type: 'POI Type',
                zipcode: 'Postcode',
            },
            import: {
                dropzone: {
                    description: 'Drag & drop of druk op Importeer je CSV-bestand met de nieuwe points of interests.',
                    title: 'Upload CSV',
                },
                title: 'Point of interests importeren van CSV bestand',
            },
            promoted_products: {
                add: 'Uitgelichte producten toevoegen',
                no_results: 'Er zijn geen uitgelichte producten',
                title: 'Uitgelichte producten',
            },
            title: 'Points of Interest',
            types: {
                accommodation: 'Accommodatie',
                airport: 'Luchthaven',
                beach: 'Strand',
                bridge: 'Brug',
                business_centre: 'Zakencentrum',
                city: 'Stad',
                cultural: 'Cultureel',
                education: 'Onderwijs',
                event: 'Evenement',
                event_center: 'Evenementencentrum',
                government_building: 'Overheidsgebouw',
                hospital: 'Ziekenhuis',
                library: 'Bibliotheek',
                museum: 'Museum',
                neighbourhood: 'Buurt',
                other: 'Overige',
                park: 'Park',
                port: 'Haven',
                recreation: 'Recreatie',
                religious_building: 'Religieus gebouw',
                restaurant: 'Restaurant',
                shopping_centre: 'Winkelcentrum',
                sight: 'Bezienswaardigheid',
                station: 'Treinstation',
            },
        },
        products: {
            actions: {
                activate: 'Activeren',
                create: 'Maak een product aan',
                deactivate: 'Deactiveren',
                edit: 'Wijzig een product',
                localisation: 'Product beschrijvingen',
                occupancy: 'Bezetting',
                resource: 'Bron',
            },
            activity: {
                activate: {
                    title: 'Het product wordt geactiveerd',
                    description: 'Het product wordt nje zichtbaar gemaakt op al onze platformen.',
                },
                deactivate: {
                    title: 'Het product wordt gedeactiveerd',
                    description: 'Het product is niet zichtbaar en de eindgebruiker zal het product niet meer zien.',
                },
            },
            administration_fee: {
                title: 'Administratiekosten',
            },
            advancedTimes: {
                title: 'Maximale en minimale geavanceerde tijden',
                fields: {
                    maximum_advance: 'Maximale geavanceerde tijd',
                    minimum_advance: 'Minimale geavanceerde tijd',
                },
            },
            allowed_capacity_excess: {
                title: 'Toegestane overcapaciteit',
                fields: {
                    capacity_excess: 'Overtollige capaciteit',
                },
            },
            attribute: 'Kenmerk',
            availability: {
                button: 'Valideer',
                dialog: {
                    description: '',
                    title: 'Valideer het product',
                },
                results: {
                    arrival_dates_blocked: 'Geblokkeerde aankomstdata',
                    available_price_information: 'Prijs beschikbaar',
                    blocked_dates: 'Geblokkeerde datums',
                    capacity: 'Capaciteit',
                    configuration: 'Productconfiguratie',
                    consumer_price: 'Consumentenprijs',
                    departure_dates_blocked: 'Geblokkeerde vertrekdata',
                    has_time_zone: 'Correcte tijdzone',
                    is_visible: 'Product is zichtbaar',
                    maximum_advance: 'Max. Advance',
                    maximum_duration: 'Max. Duur',
                    minimum_advance: 'Min. Advance',
                    minimum_duration: 'Min. Duur',
                    operational_times: 'Operationele tijden',
                    pricing_service_price: 'Prijs prijsservice',
                    product_enabled: 'Product actief',
                    provider_enabled: 'Provider actief',
                    provider_price: 'Providerprijs',
                    supported_currency: 'Valuta ondersteund',
                    supported_resource: 'Correcte resource instellingen',
                    valid_price: 'Prijs correct',
                },
            },
            arrival_dates_blocked: {
                title: 'Geblokkeerde aankomst',
                add: 'Voeg geblokkeerde aankomst toe',
                no_result: 'Er zijn geen geblokkeerde aankomstdata gevonden',
            },
            blocked_dates: {
                title: 'Geblokkeerde data',
                add: 'Geblokkeerde datum toevoegen',
                no_result: 'Er zijn geen geblokkeerde data',
            },
            capacity: {
                title: 'Capaciteit',
            },
            configuration: {
                saved: 'De productconfiguratie is succesvol opgeslagen.',
            },
            count: 'Aantal',
            departure_dates_blocked: {
                title: 'Geblokkeerde vertrekdata',
                add: 'Geblokkeerde datums toevoegen',
                no_result: 'Er zijn geen geblokkeerde vertrekdata gevonden',
            },
            duration: {
                no_duration: 'Er is geen maximale of minimale duur gevonden voor dit product.',
                fields: {
                    maximum_duration: 'Maximale duur',
                    minimum_duration: 'Minimale duur',
                },
                placeholders: {
                    duration: 'bijv 10d of 12u',
                    duration_day: 'bijv 10d',
                    duration_hour: 'bijv 12u',
                },
                response: {
                    save: 'De duur is succesvol opgeslagen',
                },
            },
            edit: {
                location: 'Locatie bewerken',
                resource: 'Resource bewerken',
            },
            fields: {
                active: 'Actief',
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'bijv 1.99, 2.50',
                    minimum: 'Minimum',
                    minimum_placeholder: 'bijv 1.99, 2.50',
                    percentage: 'Percentage',
                    percentage_placeholder: 'bijv 0.10 (10%), 0.03 (3%)',
                },
                allow_overstay: 'Overstay toestaan',
                category_id: 'Category',
                city: 'Stad',
                communicate_email_addresses: 'E-mailadressen communiceren',
                company_id: 'Provider',
                conditionz: 'Algemene voorwaarden',
                configuration: 'Configuratie',
                country_code: 'Landcode',
                country: 'Land',
                date: 'Datum',
                description_de: 'Duitse beschrijving',
                description_en: 'Engelse beschrijving',
                description_es: 'Spaanse beschrijving',
                description_fr: 'Franse beschrijving',
                description_it: 'Italiaanse beschrijving',
                description: 'Nederlandse beschrijving',
                duration: 'Maximale en minimale duur',
                email_domain: 'E-mailadres domein',
                email_from: 'E-mailadres verzonden vanuit',
                email1: 'E-mailadres van de Provider',
                email2: 'E-mailadres van de Admin',
                enabled: 'Actief',
                freeze_period: 'Periode van bevriezing',
                from: 'Van',
                icon: 'Icon',
                id: 'Id',
                inactive: 'Inactief',
                internal_qr_code: 'Interne QR-code',
                is_combined: 'Combined product',
                is_official_facility: 'Dit is een bestaande locatie',
                is_visible: 'Zichtbaar',
                key: 'Sleutel',
                leeway: 'Aankomst en vertrek speelruimte',
                location_address: 'Adres',
                location_id: 'Locatie Id',
                location_latitude: 'Latitude',
                location_longitude: 'Longitude',
                logo: 'logo',
                mail_de: 'E-mail geschreven in het Duits',
                mail_en: 'E-mail geschreven in het Engels',
                mail_fr: 'E-mail geschreven in het Frans',
                mail: 'E-mail geschreven in het Nederlands',
                map_image: 'Afbeelding van de locatie',
                number_of_persons: 'Aantal personen',
                operational_times: 'Bedrijfstijden',
                options: 'Opties',
                parking_id: 'Parking Id',
                phone: 'Telefoonnummer',
                point_of_interest_id: 'Point of interest',
                priority: 'Prioriteit',
                product_id: 'Provider',
                property_id: 'Property',
                provider_id: 'Provider',
                radius: 'Radius',
                rating: 'Beoordeling',
                resource: {
                    id: 'Resource Id',
                    name: 'Resource Naam',
                },
                service_id: 'Service',
                split_percentage: 'Split Price percentage',
                street: 'Straat',
                subcategory_id: 'Subcategory',
                terms_and_conditions: {
                    title: 'Términos y condiciones',
                    link: 'URL',
                    link_placeholder: 'Introduce la URL',
                    name: 'Nombre',
                    name_placeholder: 'Introduce el nombre',
                },
                title: 'Titel',
                to: 'Naar',
                type: 'Type',
                updated_at: 'Geüpdated',
                value: 'Waarde',
                vat_percentage: 'BTW percentage',
                voucher_include_invoice: 'Voucher inclusief factuur',
                weekday: 'Weekdag',
                zipcode: 'Postcode',
            },
            filters: {
                radius: {
                    '5': '5km',
                    '10': '10km',
                    '15': '15km',
                    '20': '20km',
                    '25': '25km',
                },
            },
            forms: {
                access_methods: 'Toegangsmethoden',
                content: 'Content',
                general: 'Algemeen',
                location: 'Locatie',
                logo: 'Logo',
                preferences: 'Voorkeuren',
                properties: 'Properties',
                provider: 'Aanbieder',
                related: 'Gerelateerde producten',
            },
            freeze_period: {
                placeholder: 'bijv. 2h',
            },
            leeway: {
                fields: {
                    leeway_arrival: 'Aankomst speelruimte',
                    leeway_departure: 'Vertrek speelruimte',
                },
                placeholders: {
                    leeway: 'bijv. 30 (min)',
                },
            },
            logo: {
                description: 'Max 300px high, Max 300px wide',
            },
            name: 'Product',
            notifications: {
                configuration: 'Er ontbreken enkele configuraties voor dit product. Ga naar de configuratiepagina om de productconfiguratie aan te passen.',
                inactive: 'Dit product is inactief. Klik op de activeringsknop om het product te activeren.',
                product_missing_data: 'Er ontbreken configuratie- en/of resourcegegevens voor dit product .',
                'product-missing-data-for-enable': 'Er ontbreken configuratie- en/of resourcegegevens voor dit product.',
                resource: 'Er ontbreekt een resource voor dit product. Ga naar de resource pagina om de productresource aan te passen.',
                vat_percentage: 'Er ontbreekt een toegepast btw-percentage voor dit product in de productconfiguraties. Ga naar de configuratiepagina om het btw-percentage aan te passen.',
            },
            number_of_persons: {
                placeholder: 'Maximaal aantal personen',
            },
            operational_times: {
                add: 'Bedrijfstijd toevoegen',
                no_result: 'Er zijn geen bedrijfstijden toegevoegd aan dit product.',
                save: 'Bedrijfstijden besparen',
                title: 'Bedrijfstijden',
            },
            occupancy: {
                graph: {
                    label: {
                        capacity: 'Capaciteit',
                        hour: {
                            capacity: 'Capaciteit per uur',
                            occupancy: 'Bezetting per uur',
                        },
                        occupancy: 'Bezetting',
                    },
                    no_results: 'Er zijn geen producten geboekt op het geselecteerde datum.',
                    title: 'Bezetting',
                },
                reservations: {
                    destination_arrival_date: {
                        no_results: 'Er zijn geen aankomende reserveringen gevonden voor de geselecteerde datum',
                        title: 'Aankomende reserveringen (%{count})',
                    },
                    destination_departure_date: {
                        no_results: 'Er zijn geen vertrekkende reserveringen gevonden voor de geselecteerde datum.',
                        title: 'Vertrekkende reserveringen (%{count})',
                    },
                    id: {
                        no_results: 'Er zijn geen andere reserveringen gevonden voor rond de geselecteerde datum. ',
                        title: 'Andere reserveringen (%{count})',
                    },
                },
            },
            title: 'Producten',
            properties: {
                no_results: 'Er zijn geen eigenschappen toegevoegd aan dit product.',
            },
            related: {
                add: 'Voeg een gerelateerd product toe',
                delete: {
                    description: 'Dit item zal permanent verwijderd worden. Deze actie kan niet ongedaan worden gemaakt.',
                    title: 'Weet je zeker dat je dit wil verwijderen?',
                },
                no_results: 'Er zijn geen gerelateerde producten',
                title: 'Gerelateerd',
            },
            require_one_of: {
                add: 'Voeg een vereist gerelateerd product toe',
                no_result: 'Er zijn geen vereiste gerelateerde producten',
                title: 'Vereis een van',
            },
            rules: 'Regels',
            sales_price: {
                add: 'Voeg een verkoopprijs eigenschap toe',
                no_result: 'Er zijn geen configuraties voor de verkoopprijzen',
                title: 'Verkoopprijs',
            },
            pages: {
                location: 'Wijzig de locatie: %{title}',
                resource: 'Wijzig de bron: %{title}',
            },
            value: {
                add: 'Voeg een %{type} toe',
                label: 'Waarde',
                no_result: 'Er zijn geen %{type} in deze configuratie.',
                save: '%{type} opslaan',
                title: 'Waarde',
                types: {
                    dates: {
                        plural: 'data',
                        singular: 'Datum',
                    },
                    email_domain: {
                        plural: 'e-mailadres domeinen',
                        singular: 'e-mailadres domein',
                    },
                    time: {
                        plural: 'tijden',
                        singular: 'Tijd',
                    },
                },
            },
            communicate_email_addresses: {
                placeholder: 'Kies of e-mailadressen worden gecommuniceerd',
                choices: {
                    do_not_send: 'Niet verzenden',
                    send: 'Verzenden',
                    send_masked: 'Gemaskeerd verzenden',
                },
            },
            voucher_include_invoice: {
                placeholder: 'bijv. ja of nee',
            },
        },
        product_memberships: {
            actions: {
                create: 'Maak een productlidmaatschap',
                edit: 'Pas de productlidmaatschap aan',
            },
            create: {
                pricing: 'We zullen de standaardprijs van het productlidmaatschap gebruiken als je het prijsveld niet bijwerkt.',
            },
            fields: {
                group_identifier: 'Groepsidentificatie',
                membership_schedule: 'Schema',
                price_ondemand: 'Prijs op aanvraag',
                price_scheduled: 'Prijs gepland',
                product_membership_id: 'Productlidmaatschap',
                supports_ondemand: 'Ondersteunt on-demand',
                supports_scheduled: 'Ondersteunt gepland',
                user_product_membership_pool_id: 'Lidmaatschapsgroep',
                user_vehicle_id: 'Voertuig',
                deferred: 'Uitgesteld',
                payment_method_description: 'Standaard is de betaalmethode ingesteld op Factuur. Als je de uitgestelde betaling wilt gebruiken, vink dan het selectievakje hieronder aan.',
            },
            no_results: 'Er zijn geen productlidmaatschappen',
            title: 'ProductLidmaatschappen',
        },
        profile: {
            name: 'Profile',
        },
        properties: {
            actions: {
                create: 'Maak een eigenschap aan',
                edit: 'Bewerk de eigenschap',
                show: 'Eigenschap: %{title}',
            },
            fields: {
                icon: 'Icoon',
                name: 'Name',
                priority: 'Priority',
                property_group_id: 'Property group',
            },
            languages: {
                label: 'Selecteer een taal',
            },
            title: 'Eigenschappen',
            validate: {
                property_group_id: 'Vul een eigenschapsgroep in',
                'property-groups-not-available': 'Eigenschapsgroep is niet beschikbaar.',
            },
        },
        propertygroups: {
            actions: {
                create: 'Maak een property groep aan',
                edit: 'Wijzig de property groep: %{title}',
                show: 'Property group: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Name',
                properties: 'Properties',
                property: 'Property',
            },
            languages: {
                label: 'Selecteer een taal',
            },
            name: 'Property group',
            plural: 'Property groups',
        },
        reservations: {
            fields: {
                booking_order_id: 'Client Mobian ID',
                cancelled_at: 'Geannuleerd op',
                created_at: 'Gemaakt',
                customer: 'Klant',
                placeholder: 'Aanmaakdatum',
                customer_remarks: 'Klant Opmerkingen',
                destination_address: 'Afzet locatie',
                destination_arrival_date: 'Aankomstdatum',
                destination_departure_date: 'Vertrekdatum',
                drop_off_date: 'Afleverdatum',
                ending_at: 'Eindigd om',
                flight_number: 'Vluchtnummer',
                full_name: 'Naam',
                internal_order_id: 'Order ID',
                last_name: 'Achternaam',
                license_plate: 'Nummerplaat',
                number_of_persons: 'Aantal personen',
                origin_address: 'Ophaalplaats',
                phone: 'Telefoon',
                pick_up_date: 'Ophaaldatum',
                product: 'Product',
                remote_reference: 'Externe referentie',
                return_flight_number: 'Vluchtnummer terug',
                starting_at: 'Start vanaf',
                subscription_id: 'Abonnement ID',
                subscription_reservation_id: 'Abonnement reservering ID',
                updated_at: 'Laatst bijgewerkt',
            },
            name: 'Reservering',
            open_barrier: {
                modal: {
                    error: 'Oeps, er is iets misgegaan bij het openen van de slagboom. Probeer het later opnieuw.',
                    force_not_allowed_for_access_method: 'De slagboom is niet toegestaan voor deze toegangs­methode.',
                    session_open_barrier_requires_access_point: 'Het openen van de slagboom in deze sessie vereist een toegangspunt.',
                    success: 'De slagboom is succesvol geopend.',
                },
                title: 'Slagboom openen',
            },
            title: 'Reserveringen',
            session: {
                asset_not_usable: {
                    description: 'Je kunt het opnieuw proberen met een geforceerde stop. Hiermee wordt de sessie altijd beëindigd en wordt het asset teruggezet naar ‘beschikbaar’ als de sessie met een asset is gestart.',
                    title: 'Het stoppen van de sessie is mislukt vanwege de volgende vereisten:',
                },
                button: {
                    end: 'Stop de sessie',
                    start: 'Start de sessie',
                    open_barrier: 'Slagboom openen',
                },
                modal: {
                    button: {
                        submit: {
                            end: 'Stop de sessie',
                            start: 'Start de sessie',
                        },
                    },
                    callback: {
                        end: {
                            error: 'Oeps, er is iets misgegaan bij het beëindigen van de sessie. Probeer het later opnieuw',
                            success: 'De sessie is succesvol beëindigd.',
                        },
                        start: {
                            error: 'Oeps, er is iets misgegaan bij het starten van de sessie. Probeer het later opnieuw',
                            success: 'De sessie is succesvol gestart.',
                        },
                    },
                    checkbox: 'Open de poort',
                    force: 'Forceer stop sessie',
                    description: {
                        end: 'De huidige reserveringssessie is al begonnen. Klik op het selectievakje als je het hek wilt openen of sluiten.',
                        start: 'De huidige reserveringssessie is nog niet gestart. Klik op het selectievakje als je het hek wilt openen of sluiten.',
                    },
                    title: {
                        end: 'Stop de sessie',
                        start: 'Start de sessie',
                    },
                },
            },
            show: {
                activities: {
                    access_sessions: {
                        title: 'Toegangssessies',
                        not_found: 'Er zijn geen toegangssessieactiviteiten gevonden voor deze reservering',
                    },
                },
                booking_information: 'Boekingsinformatie',
                product: 'Product',
                reservation_details: 'Reserveringsdetails',
                reservation_price: 'Reserveringsprijs',
                travel_details: 'Reisgegevens',
            },
        },
        subcategories: {
            actions: {
                create: 'Maak een subcategorie',
                edit: 'Bewerk de subcategorie',
                show: 'Subcategorie: %{title}',
            },
            fields: {
                id: 'Id',
                name: 'Naam',
                category_id: 'Categorie',
            },
            languages: {
                label: 'Selecteer een taal',
            },
            title: 'Subcategories',
            validate: {
                'categories-not-available': 'Er zijn geen categorieën aanwezig.',
            },
        },
        subscriptions: {
            actions: {
                create: 'Maak',
                edit: 'Bewerken',
            },
            fields: {
                account: 'Rekening',
                company_name: 'Bedrijfsnaam',
                currency: 'Valuta',
                email: 'Email',
                end_date: 'Einddatum',
                first_name: 'Voornaam',
                full_name: 'Volledige naam',
                last_name: 'Achternaam',
                language: 'Taal',
                license_plate: 'Kentekenplaat',
                name: 'Naam',
                order_id: 'Bestel ID',
                phone: 'Telefoon',
                price: 'Prijs',
                start_date: 'Begindatum',
                status: 'Status',
                terminated_at: 'Beëindigd op',
            },
            show: {
                subscription_details: 'Abonnementsgegevens',
                subscription: 'Abonnement',
            },
            tooltips: {
                ok: 'Ok',
                pending: 'Inschrijving: in behandeling',
                under_review: 'Abonnement: wordt herzien',
            },
            title: 'Abonnementen',
        },
        subscriptionProducts: {
            create: {
                title: 'Product voor abonnementen toevoegen',
            },
            fields: {
                end_time: 'Eindtijd',
                start_time: 'Starttijd',
                day: 'Dag',
                product: 'Product',
            },
            input: {
                day: {
                    1: 'Maandag',
                    2: 'Dinsdag',
                    3: 'Woensdag',
                    4: 'Donderdag',
                    5: 'Vrijdag',
                    6: 'Zaterdag',
                    7: 'Zondag',
                },
            },
            no_results: 'Er zijn geen abonnementsproducten gevonden.',
            title: 'Abonnementsproducten',
        },
        users: {
            actions: {
                activate: 'Activeren',
                create: 'Maak een gebruiker aan',
                deactivate: 'Deactiveren',
                edit: 'Pas de gebruiker aan',
                reset_password: 'Reset Password',
            },
            activity: {
                activate: {
                    title: 'De gebruiker wordt geactiveerd',
                    description: 'Wanneer de gebruiker actief is kan deze inloggen in het dashboard, de apps en onze services gebruiken.',
                },
                deactivate: {
                    title: 'De gebruiker wordt gedeactiveerd',
                    description: 'Wanneer de gebruik inactief is kan deze niet langer inloggen in het dashboard, de apps en onze services gebruiken.',
                },
            },
            delete: {
                warnings: {
                    'user-has-active-memberships': 'Er bestaan actieve lidmaatschappen voor deze gebruiker.',
                    'user-has-active-subscriptions': 'Er zijn actieve abonnementen voor deze gebruiker.',
                    'user-has-future-bookings': 'Er bestaan toekomstige boekingen voor deze gebruiker.',
                    'user-has-invoicable-bookings': 'Er bestaan factureerbare boekingen voor deze gebruiker.',
                    'user-has-open-invoices': 'Er bestaan openstaande facturen voor deze gebruiker.',
                    'user-has-overdue-invoices': 'Er bestaan achterstallige facturen voor deze gebruiker.',
                    'user-has-recent-recurring-payment-activity': 'Er bestaat recente terugkerende betalingsactiviteit voor deze gebruiker.',
                    'user-has-wallet-funds': 'Er zijn portemonneefondsen toegevoegd voor deze gebruiker.',
                },
            },
            fields: {
                active: 'Actief',
                address: 'Adres',
                bic: 'BIC',
                city: 'Stad',
                company_email: 'Bedrijfs E-mail',
                company_name: 'Bedrijfsnaam',
                company_registration: 'KVK nummer',
                company_vat: 'BTW nummer',
                contract: 'Contract',
                country: 'Land',
                email: 'E-mail',
                external_yield: 'Externe Yield',
                firstname: 'Voornaam',
                iban: 'IBAN',
                lastname: 'Achternaam',
                locale: 'Taal',
                logo: 'Logo',
                membership_id: 'Lidmaatschap',
                name: 'Naam',
                orders: 'Orders',
                phonenumber: 'Telefoon',
                product_commission_reseller: 'Reseller Product commissie',
                provider_id: 'Provider',
                reseller_id: 'Reseller',
                role: 'Role',
                title: 'Titel',
                url: 'URL',
                user_id: 'Reseller',
                username: 'Gebruikernaam',
                vat: 'BTW',
                yield_commission: 'Yield commissie',
                zipcode: 'Postcode',
            },
            filters: {
                active: {
                    active: 'Alleen actief',
                    inactive: 'Alleen inactief',
                },
            },
            forms: {
                account: 'Accountgegevens',
                address: 'Adresgegevens',
                company: 'Bedrijfsgegevens',
                contact: 'Contactgegevens',
                general: 'Algemeen',
                products: 'Laatst bijgewerkte producten',
                registrations: 'Registraties',
            },
            memberships: {
                create: 'Gebruikerslidmaatschap aanmaken',
                edit: 'Gebruikerslidmaatschap aanpassen (%{name})',
                no_results: 'Er zijn geen lidmaatschappen gekoppeld met deze gebruiker',
                pricing: 'Prijsstelling',
            },
            name: 'Gebruiker',
            no_results: 'Er zijn geen gebruikers gevonden.',
            not_found: 'Er is geen gebruiker gevonden.',
            notifications: {
                inactive: 'Deze gebruiker is inactief. Klik op de activeringsknop om de gebruiker te activeren.',
                not_confirmed: 'Deze gebruiker heeft zijn/haar account nog niet bevestigd.',
            },
            title: 'Gebruikers',
            products: {
                actions: {
                    list: 'Toon alle producten (%{total})',
                },
            },
            // User-product-memberships create and edit
            product_memberships: {
                actions: {
                    create: 'Maak een gebruikersproductlidmaatschap',
                    edit: 'Pas de gebruikersproductlidmaatschap aan',
                },
            },
            reset_password: {
                description: 'Als je een wachtwoord opnieuw instelt, stuurt je een nieuw wachtwoord naar de e-mail van de gebruiker. Het oude wachtwoord is niet langer bruikbaar. Op dit moment ingelogde sessies van deze gebruiker moeten ze zich opnieuw aanmelden op alle apparaten met hun nieuwe wachtwoord.',
                title: 'Reset het wachtwoord van de gebruiker',
            },
            roles: {
                reseller: 'Reseller',
                provider: 'Provider',
            },
        },
        wallets: {
            fields: {
                amount: 'Bedrag',
                balance: 'Saldo',
                reason: 'Reden',
                type: 'Type',
            },
            no_results: 'Er zijn geen portemonnees gevonden.',
            title: 'Portemonnees',
            topup: {
                notifications: {
                    success: {
                        decrease: 'De gebruikersportefeuille is succesvol afgenomen.',
                        increase: 'De gebruikersportefeuille is successvol toegenomen.',
                    },
                },
                label: 'Bijvullen',
                title: 'Portemonnee bijvullen',
            },
        },
        webhooks: {
            actions: {
                create: 'Maak een Webhook',
                edit: 'Webhook Aanpassen: %{title}',
            },
            fields: {
                action_booking_cancelled: 'Actie Reservering Geannuleerd',
                action_booking_created: 'Actie Reservering Gemaakt',
                action_booking_initialised: 'Actie Reservering Geïnitialiseerd',
                action_booking_modified: 'Actie Reservering Gewijzigd',
                action_booking_under_review: 'Actie Reservering Wordt Herzien',
                action_reservation_cancelled: 'Actie Reservering Geannuleerd',
                action_reservation_created: 'Actie Reservering Gemaakt',
                action_reservation_modified: 'Actie Reservering Gewijzigd',
                is_active: 'Actief',
                name: 'naam',
                url: 'url',
            },
            forms: {
                actions: 'Acties',
                general: 'Algemeen',
            },
            title: 'Webhooks',
        },
    },
    page: {
        page_not_found: {
            title: 'Pagina niet gevonden',
            description: 'De pagina die je zoekt, is niet gevonden.',
        },
        resource_not_found: {
            description: 'We konden het element die je zoekt niet vinden.',
            title: 'Element kon niet gevonden worden!',
        },
        not_authorised: {
            title: 'Oh..',
            description: 'Het lijkt erop dat je niet bevoegd bent om deze pagina te zien.',
        },
    },
    release: {
        list: {
            description: 'In deze release hebben we een aantal kleine aanpassingen aan de overzichtpagina\'s gedaan. Je kunt nje klikken op een rij om naar de detail pagina te gaan.',
            title: 'Kleine update aan onze overzichtspagina\'s',
        },
    },
    signUp: {
        errors: {
            passowrd_chars: 'Wachtwoord moet minstens 6 tekens bevatten',
            same_email: 'E-mails moeten gelijk zijn',
            same_password: 'Wachtwoorden moeten gelijk zijn',
        },
        fields: {
            confirm_email: 'E-mail bevestigen',
            confirm_password: 'Bevestig wachtwoord',
        },
        no_account: 'Ik heb geen account',
        title: 'Inschrijven',
        success: 'Gebruiker is succesvol geregistreerd',
    },
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js